import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=321f4960&scoped=true"
import script from "./PromptDialog.vue?vue&type=script&lang=ts"
export * from "./PromptDialog.vue?vue&type=script&lang=ts"
import style0 from "./PromptDialog.vue?vue&type=style&index=0&id=321f4960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f4960",
  null
  
)

export default component.exports